import {
	COUNTRY_CODE_GET_FAIL,
	COUNTRY_CODE_GET_REQUEST,
	COUNTRY_CODE_GET_SUCCESS,
} from '../constants/countryCodeConstants';

export const countryCodesReducer = (
	state = { countryCodesData: {} },
	action
) => {
	switch (action.type) {
		case COUNTRY_CODE_GET_REQUEST:
			return {
				...state,
				loading: true,
			};

		case COUNTRY_CODE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				countryCodesData: action.payload,
			};
		case COUNTRY_CODE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
